<template>
  <v-card class="main-card">
    <v-card-text>

      <div>
        <p><strong>In short:</strong></p>
        <ul>
          <li>Monetise on GSMG automated trading technology</li>
	  <li>Create and manage GSMG accounts for your customers, including all available subscription plans</li>	  
          <li>Easy access through the <a class="link" href="#" @click.prevent="changeTab">GSMG REST API</a></li>

          <li>Premium tech support</li>
        </ul>
      </div>
      <div class="mt-3">
        <p><strong>Cost and benefit</strong></p>
        <ul>
          <li>GSMG will payout to you 35% of each of your customers' deposits to their GSMG accounts created by you</li>
	  <li>Those accounts will ofcourse be credited 100% in "fuel"</li>
	  <li>The payouts to you are in kind, that is in ETH and/or BNB and not in "fuel"</li>
          <li>
            Note that these payouts will start after the sum total of (all) your customers' deposits
            will have exceeded 5000 USD in worth and only for deposits after that 
          </li>
        </ul>
      </div>

    </v-card-text>
  </v-card>
</template>

<style scoped>
.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--light .link {
  color: #468aff;
}
.theme--light p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
.theme--light ul li {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
/*******************************/

.theme--dark .main-card {
  background: #212121;
  box-shadow: none;
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--dark .link {
  color: #639bfb;
}
.theme--dark p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}
.theme--dark ul li {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}
</style>

<script>
import swal from "sweetalert2";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

export default {
  data() {
    return {
      pagination: {
        descending: true,
        sortBy: "ts_utc_secs",
        rowsPerPage: 10
      },
      deposits: [],
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    tableHeaders() {
      if (this.isMobile) {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          }
        ];
      } else {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          },
          { text: "Amount", value: "value_cur" },
          { text: "Currency", value: "cur" },
          { text: "USD worth", value: "value_usd" }
        ];
      }
    }
  },
  mounted: async function() {
    axios.get("/api/v1/deposits").then(res => {
      if (res.data) {
        this.deposits = res.data;
      }
    });
  },
  methods: {
    changeTab: function() {
      this.$emit("changeTab", {
        tab: 4
      });
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    },
    changeSort: function(header) {
      this.pagination.sortBy = header.value;
      this.pagination.descending = !this.pagination.descending;
    },
    customTableSort(items, index, isDescending) {
      const factor = isDescending ? -1 : 1;

      items.sort((a, b) => {
        const aValue = a[index];
        const bValue = b[index];

        if (aValue === bValue) {
          return 0;
        }

        return factor * (aValue < bValue ? -1 : 1);
      });

      return items;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/whitelabel/General.vue